import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const StepLabel = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '10px',
  lineHeight: '150%',
  letterSpacing: 0,
  color: '#777777',
  textAlign: 'center',
  marginBottom: theme.spacing(0.5),
}))

export const IconWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  height: 20,
  marginBottom: 4,
}))